const masterListActionTypes = {
  FETCH_SERVICES: 'FETCH_SERVICES',
  FETCH_SERVICES_SUCCESS: 'FETCH_SERVICES_SUCCESS',
  FETCH_SERVICES_FAIL: 'FETCH_SERVICES_FAIL',
  FETCH_ADD_SERVICE_SUBMISSION: 'FETCH_ADD_SERVICE_SUBMISSION',
  FETCH_ADD_SERVICE_SUBMISSION_SUCCESS: 'FETCH_ADD_SERVICE_SUBMISSION_SUCCESS',
  FETCH_ADD_SERVICE_SUBMISSION_FAIL: 'FETCH_ADD_SERVICE_SUBMISSION_FAIL',
};

export default masterListActionTypes;
